require('./RASetGoalStepHeader.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

class RASetGoalStepHeader extends React.Component {
    render() {
        const { active, description, title } = this.props;
        const iconClass = classNames('ra-set-goal-step-header__icon', {
            'ra-set-goal-step-header__icon--active': !active,
            'ra-set-goal-step-header__icon--checked icon-success': active,
        });

        return (
            <div className="ra-set-goal-step-header">
                <i className={iconClass} />
                <div className="ra-set-goal-step-header__title">{title}</div>
                <div className="ra-set-goal-step-header__description">{description}</div>
            </div>
        );
    }
}

RASetGoalStepHeader.propTypes = {
    active: PropTypes.bool.isRequired,
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = RASetGoalStepHeader;
